import { Settings } from "../Settings";
import {controlsLocalizationData} from './ControlsLocalization.js';
import {multiplayerLocalizationData} from './MultiplayerLocalization.js';

const languageDataBase = {};

const init = ()=>{
	parseLocalization();
}
const parseLocalization = ()=>{
	LOCALIZATION_DATA.forEach(data => {
		const id = data.textId;
		const keys = Object.keys(data);
		keys.forEach( language => {
			if(language != 'textId'){
				if(!languageDataBase[id]) languageDataBase[id] = {};
				languageDataBase[id][language] = data[language];
			}
		})
	})
}

export const localize = (id, values = {}) =>{
	let text = '?';
	if(languageDataBase[id]){
		text = languageDataBase[id][Settings.currentCountry];
		if(!text) text = languageDataBase[id]['us']
	}
	return text.replace(/\{(\w+)\}/g, (placeholder, name) =>
		Object.hasOwn(values, name) ? String(values[name]) : placeholder);
}

export const countries = ['us','de','jp','pt','fr','es','it','nl','ru','cz','jr'];

const LOCALIZATION_DATA = [
    ...controlsLocalizationData,
    ...multiplayerLocalizationData,
    { "textId": "settings_language", "us": "Language", "nl": "Taal", "de": "Sprache", "es": "Idioma", "pt": "Idioma", "cz": "Jazyk", "fr": "Langue", "it": "Lingua", "jr": "Lingo", "jp": "言語", "ru": "Язык" },
    {"textId":"userpage_nolevels","us":"No published levels yet.","nl":"Nog geen gepubliceerde levels.","de":"Noch keine veröffentlichten Level.","fr":"Aucun niveau publié pour le moment.","es":"Todavía no hay niveles publicados.","pt":"Ainda não há níveis publicados.","it":"Nessun livello pubblicato per ora.","cz":"Zatím žádné zveřejněné úrovně.","jp":"公開されたレベルはまだありません。","ru":"Пока нет опубликованных уровней.","jr":"No islands published yet, matey."},
    {"textId":"userpage_nofavorites","us":"No favorite levels yet.","nl":"Nog geen favoriete levels.","de":"Noch keine Lieblingslevel.","fr":"Aucun niveau favori pour le moment.","es":"Todavía no hay niveles favoritos.","pt":"Ainda não há níveis favoritos.","it":"Nessun livello preferito per ora.","cz":"Zatím žádné oblíbené úrovně.","jp":"お気に入りのレベルはまだありません。","ru":"Пока нет избранных уровней.","jr":"No treasured levels yet."},
    {"textId":"userpage_loaderror","us":"This profile could not be loaded. Please try again.","nl":"Dit profiel kon niet worden geladen. Probeer het opnieuw.","de":"Dieses Profil konnte nicht geladen werden. Bitte versuche es erneut.","fr":"Impossible de charger ce profil. Veuillez réessayer.","es":"No se ha podido cargar este perfil. Inténtalo de nuevo.","pt":"Não foi possível carregar este perfil. Tenta novamente.","it":"Impossibile caricare questo profilo. Riprova.","cz":"Tento profil se nepodařilo načíst. Zkus to znovu.","jp":"プロフィールを読み込めませんでした。もう一度お試しください。","ru":"Не удалось загрузить профиль. Попробуйте ещё раз.","jr":"This pirate’s profile failed to load. Try again, matey."},
    {"textId":"userpage_notfound","us":"User not found.","nl":"Gebruiker niet gevonden.","de":"Benutzer nicht gefunden.","fr":"Utilisateur introuvable.","es":"Usuario no encontrado.","pt":"Utilizador não encontrado.","it":"Utente non trovato.","cz":"Uživatel nenalezen.","jp":"ユーザーが見つかりません。","ru":"Пользователь не найден.","jr":"No such pirate found."},
    {"textId":"rank_levelup","us":"Level up!","nl":"Level omhoog!","de":"Level up!","fr":"Niveau supérieur !","es":"¡Subes de nivel!","pt":"Subiste de nível!","it":"Livello superiore!","cz":"Nová úroveň!","jp":"レベルアップ！","ru":"Новый уровень!","jr":"Ye leveled up!"},
    {"textId":"rank_newrank","us":"New rank!","nl":"Nieuwe rang!","de":"Neuer Rang!","fr":"Nouveau rang !","es":"¡Nuevo rango!","pt":"Nova patente!","it":"Nuovo grado!","cz":"Nová hodnost!","jp":"ランクアップ！","ru":"Новый ранг!","jr":"Promoted, matey!"},
    {"textId":"rank_level","us":"LVL {level}","nl":"LVL {level}","de":"LVL {level}","fr":"NIV. {level}","es":"NV. {level}","pt":"NV. {level}","it":"LIV. {level}","cz":"LVL {level}","jp":"Lv.{level}","ru":"УР. {level}","jr":"LVL {level}"},
    {"textId":"rank_unranked","us":"Unranked","nl":"Geen rang","de":"Ohne Rang","fr":"Sans rang","es":"Sin rango","pt":"Sem patente","it":"Senza grado","cz":"Bez hodnosti","jp":"ランクなし","ru":"Без ранга","jr":"Landlubber"},
    {"textId":"rank_max","us":"Max rank","nl":"Hoogste rang","de":"Höchster Rang","fr":"Rang max","es":"Rango máximo","pt":"Patente máxima","it":"Grado massimo","cz":"Nejvyšší hodnost","jp":"最高ランク","ru":"Макс. ранг","jr":"Pirate King"},
    {"textId":"rank_position","us":"#{rank} of {total}","nl":"#{rank} van {total}","de":"#{rank} von {total}","fr":"#{rank} sur {total}","es":"#{rank} de {total}","pt":"#{rank} de {total}","it":"#{rank} su {total}","cz":"#{rank} z {total}","jp":"{total}人中{rank}位","ru":"#{rank} из {total}","jr":"#{rank} of {total} pirates"},
    {"textId":"rank_next","us":"Next rank","nl":"Volgende rang","de":"Nächster Rang","fr":"Rang suivant","es":"Siguiente rango","pt":"Próxima patente","it":"Grado successivo","cz":"Další hodnost","jp":"次のランク","ru":"Следующий ранг","jr":"Next promotion"},
    {"textId":"discord_strip_title","us":"Your {rank} role is waiting","nl":"Je {rank}-rol staat klaar","de":"Deine Rolle {rank} wartet auf dich","fr":"Ton rôle {rank} t’attend","es":"Tu rol {rank} te está esperando","pt":"O teu cargo {rank} está à tua espera","it":"Il tuo ruolo {rank} ti aspetta","cz":"Tvoje role {rank} na tebe čeká","jp":"{rank}のロールが待っています","ru":"Ваша роль {rank} уже ждёт","jr":"Yer {rank} role be waitin'"},
    {"textId":"discord_strip_body","us":"Join the JollyWorld Discord and it shows next to your name.","nl":"Word lid van de JollyWorld-Discord en hij staat naast je naam.","de":"Tritt dem JollyWorld-Discord bei und sie erscheint neben deinem Namen.","fr":"Rejoins le Discord de JollyWorld et il s’affichera à côté de ton nom.","es":"Únete al Discord de JollyWorld y aparecerá junto a tu nombre.","pt":"Entra no Discord do JollyWorld e ele aparece ao lado do teu nome.","it":"Entra nel Discord di JollyWorld e apparirà accanto al tuo nome.","cz":"Připoj se na JollyWorld Discord a zobrazí se u tvého jména.","jp":"JollyWorldのDiscordに参加すると、名前の横に表示されます。","ru":"Присоединяйтесь к Discord JollyWorld, и она появится рядом с вашим именем.","jr":"Join the JollyWorld Discord an' it shows next to yer name."},
    {"textId":"discord_perk_chat","us":"Chat with level makers and other players","nl":"Praat met levelmakers en andere spelers","de":"Chatte mit Level-Erstellern und anderen Spielern","fr":"Discute avec les créateurs de niveaux et d’autres joueurs","es":"Charla con creadores de niveles y otros jugadores","pt":"Conversa com criadores de níveis e outros jogadores","it":"Chatta con i creatori di livelli e altri giocatori","cz":"Chatuj s tvůrci úrovní a dalšími hráči","jp":"レベル制作者やほかのプレイヤーとチャット","ru":"Общайтесь с авторами уровней и другими игроками","jr":"Chat with level builders an' fellow pirates"},
    {"textId":"discord_perk_updates","us":"Hear about big updates first","nl":"Hoor als eerste over grote updates","de":"Erfahre als Erster von großen Updates","fr":"Découvre les grandes mises à jour en premier","es":"Entérate antes que nadie de las grandes actualizaciones","pt":"Sabe primeiro das grandes atualizações","it":"Scopri per primo i grandi aggiornamenti","cz":"Dozvíš se o velkých aktualizacích jako první","jp":"大型アップデートの情報をいち早くチェック","ru":"Первыми узнавайте о крупных обновлениях","jr":"Hear o' big updates first"},
    {"textId":"discord_perk_rank","us":"Your rank next to your name, levelling up as you play","nl":"Je rang naast je naam, die meegroeit terwijl je speelt","de":"Dein Rang neben deinem Namen, der beim Spielen wächst","fr":"Ton rang à côté de ton nom, qui monte pendant que tu joues","es":"Tu rango junto a tu nombre, que sube mientras juegas","pt":"A tua patente ao lado do teu nome, que sobe enquanto jogas","it":"Il tuo grado accanto al nome, che sale mentre giochi","cz":"Tvoje hodnost u jména, která roste, jak hraješ","jp":"名前の横にランクを表示、遊ぶほどレベルアップ","ru":"Ваш ранг рядом с именем растёт, пока вы играете","jr":"Yer rank next to yer name, risin' as ye play"},
    {"textId":"discord_join","us":"Join Discord","nl":"Discord joinen","de":"Discord beitreten","fr":"Rejoindre Discord","es":"Unirse a Discord","pt":"Entrar no Discord","it":"Entra su Discord","cz":"Připojit se na Discord","jp":"Discordに参加","ru":"Вступить в Discord","jr":"Join the Discord"},
    {"textId":"discord_join_short","us":"Join","nl":"Joinen","de":"Beitreten","fr":"Rejoindre","es":"Unirse","pt":"Entrar","it":"Entra","cz":"Připojit","jp":"参加","ru":"Вступить","jr":"Join"},
    {"textId":"discord_claim","us":"Claim","nl":"Ophalen","de":"Abholen","fr":"Récupérer","es":"Reclamar","pt":"Reclamar","it":"Riscatta","cz":"Získat","jp":"受け取る","ru":"Забрать","jr":"Plunder"},
    {"textId":"discord_joining","us":"Joining…","nl":"Lid worden…","de":"Trete bei…","fr":"Ajout…","es":"Uniéndote…","pt":"A entrar…","it":"Ingresso…","cz":"Připojování…","jp":"参加中…","ru":"Вступаем…","jr":"Boardin'…"},
    {"textId":"discord_hide","us":"Hide for now","nl":"Voorlopig verbergen","de":"Vorerst ausblenden","fr":"Masquer pour l’instant","es":"Ocultar por ahora","pt":"Esconder por agora","it":"Nascondi per ora","cz":"Zatím skrýt","jp":"今は非表示","ru":"Пока скрыть","jr":"Stow it fer now"},
    {"textId":"discord_toast_level","us":"Show your level in our Discord","nl":"Laat je level zien in onze Discord","de":"Zeig dein Level in unserem Discord","fr":"Affiche ton niveau sur notre Discord","es":"Muestra tu nivel en nuestro Discord","pt":"Mostra o teu nível no nosso Discord","it":"Mostra il tuo livello nel nostro Discord","cz":"Ukaž svou úroveň na našem Discordu","jp":"Discordでレベルを見せよう","ru":"Покажите свой уровень в нашем Discord","jr":"Show off yer level in our Discord"},
    {"textId":"discord_toast_rank","us":"Claim the {rank} role in our Discord","nl":"Haal de {rank}-rol op in onze Discord","de":"Hol dir die Rolle {rank} in unserem Discord","fr":"Récupère le rôle {rank} sur notre Discord","es":"Reclama el rol {rank} en nuestro Discord","pt":"Reclama o cargo {rank} no nosso Discord","it":"Riscatta il ruolo {rank} nel nostro Discord","cz":"Získej roli {rank} na našem Discordu","jp":"Discordで{rank}のロールを受け取ろう","ru":"Заберите роль {rank} в нашем Discord","jr":"Claim the {rank} role in our Discord"},
    {"textId":"discord_profile_title","us":"Your rank is a role in the JollyWorld Discord","nl":"Je rang is een rol in de JollyWorld-Discord","de":"Dein Rang ist eine Rolle im JollyWorld-Discord","fr":"Ton rang est un rôle sur le Discord de JollyWorld","es":"Tu rango es un rol en el Discord de JollyWorld","pt":"A tua patente é um cargo no Discord do JollyWorld","it":"Il tuo grado è un ruolo nel Discord di JollyWorld","cz":"Tvoje hodnost je role na JollyWorld Discordu","jp":"あなたのランクはJollyWorld Discordのロールです","ru":"Ваш ранг — это роль в Discord JollyWorld","jr":"Yer rank be a role in the JollyWorld Discord"},
    {"textId":"discord_profile_body","us":"Join and {rank} shows next to your name there.","nl":"Word lid en {rank} staat daar naast je naam.","de":"Tritt bei und {rank} steht dort neben deinem Namen.","fr":"Rejoins-le et {rank} s’affichera à côté de ton nom.","es":"Únete y {rank} aparecerá junto a tu nombre.","pt":"Entra e {rank} aparece ao lado do teu nome.","it":"Entra e {rank} apparirà accanto al tuo nome.","cz":"Připoj se a {rank} se ti zobrazí u jména.","jp":"参加すると、名前の横に{rank}が表示されます。","ru":"Присоединяйтесь, и {rank} появится рядом с вашим именем.","jr":"Join an' {rank} shows next to yer name there."},
    {"textId":"discord_profile_member","us":"Showing as {rank} in the JollyWorld Discord","nl":"Zichtbaar als {rank} in de JollyWorld-Discord","de":"Im JollyWorld-Discord als {rank} sichtbar","fr":"Affiché comme {rank} sur le Discord de JollyWorld","es":"Apareces como {rank} en el Discord de JollyWorld","pt":"Apareces como {rank} no Discord do JollyWorld","it":"Visibile come {rank} nel Discord di JollyWorld","cz":"Na JollyWorld Discordu jako {rank}","jp":"JollyWorld Discordで{rank}として表示中","ru":"В Discord JollyWorld вы — {rank}","jr":"Sailin' as {rank} in the JollyWorld Discord"},
    {"textId":"discord_open","us":"Open Discord","nl":"Discord openen","de":"Discord öffnen","fr":"Ouvrir Discord","es":"Abrir Discord","pt":"Abrir o Discord","it":"Apri Discord","cz":"Otevřít Discord","jp":"Discordを開く","ru":"Открыть Discord","jr":"Open the Discord"},
    {"textId":"discord_popup_title","us":"Your rank is waiting!","nl":"Je rang staat klaar!","de":"Dein Rang wartet!","fr":"Ton rang t’attend !","es":"¡Tu rango te espera!","pt":"A tua patente está à espera!","it":"Il tuo grado ti aspetta!","cz":"Tvoje hodnost čeká!","jp":"ランクが待っています！","ru":"Ваш ранг ждёт!","jr":"Yer rank be waitin'!"},
    {"textId":"discord_popup_joinas","us":"You'll join as","nl":"Je komt binnen als","de":"Du trittst bei als","fr":"Tu arriveras en tant que","es":"Entrarás como","pt":"Vais entrar como","it":"Entrerai come","cz":"Připojíš se jako","jp":"参加時のランク","ru":"Вы войдёте как","jr":"Ye'll board as"},
    {"textId":"discord_notnow","us":"Not now","nl":"Niet nu","de":"Nicht jetzt","fr":"Pas maintenant","es":"Ahora no","pt":"Agora não","it":"Non ora","cz":"Teď ne","jp":"今はしない","ru":"Не сейчас","jr":"Not now, matey"},
    {"textId":"discord_popup_note","us":"Discord asks you to confirm once. We never post for you.","nl":"Discord vraagt je één keer om te bevestigen. We posten nooit namens jou.","de":"Discord fragt dich einmal nach einer Bestätigung. Wir posten nie in deinem Namen.","fr":"Discord te demande de confirmer une fois. Nous ne publions jamais à ta place.","es":"Discord te pide que confirmes una vez. Nunca publicamos por ti.","pt":"O Discord pede-te para confirmares uma vez. Nunca publicamos por ti.","it":"Discord ti chiede di confermare una volta. Non pubblichiamo mai al posto tuo.","cz":"Discord tě jednou požádá o potvrzení. Nikdy za tebe nic nezveřejníme.","jp":"Discordで一度だけ確認されます。あなたの代わりに投稿することはありません。","ru":"Discord один раз попросит подтверждение. Мы никогда не публикуем от вашего имени.","jr":"Discord asks ye to confirm once. We never post in yer name."},
    {"textId":"discord_joined_title","us":"You're in!","nl":"Je bent binnen!","de":"Du bist dabei!","fr":"C’est fait !","es":"¡Ya estás dentro!","pt":"Já estás dentro!","it":"Ci sei!","cz":"Jsi tam!","jp":"参加完了！","ru":"Вы с нами!","jr":"Welcome aboard!"},
    {"textId":"discord_joined_welcome","us":"Welcome, {name}","nl":"Welkom, {name}","de":"Willkommen, {name}","fr":"Bienvenue, {name}","es":"¡Hola, {name}!","pt":"Olá, {name}!","it":"Ciao, {name}!","cz":"Vítej, {name}","jp":"ようこそ、{name}さん","ru":"Добро пожаловать, {name}","jr":"Ahoy, {name}"},
    {"textId":"discord_joined_body","us":"Your {rank} role is live in the JollyWorld Discord.","nl":"Je {rank}-rol staat nu in de JollyWorld-Discord.","de":"Deine Rolle {rank} ist jetzt im JollyWorld-Discord aktiv.","fr":"Ton rôle {rank} est actif sur le Discord de JollyWorld.","es":"Tu rol {rank} ya está activo en el Discord de JollyWorld.","pt":"O teu cargo {rank} já está ativo no Discord do JollyWorld.","it":"Il tuo ruolo {rank} è attivo nel Discord di JollyWorld.","cz":"Tvoje role {rank} je na JollyWorld Discordu aktivní.","jp":"JollyWorld Discordで{rank}のロールが有効になりました。","ru":"Ваша роль {rank} уже активна в Discord JollyWorld.","jr":"Yer {rank} role be flyin' in the JollyWorld Discord."},
    {"textId":"discord_joined_body_unranked","us":"Say hi in the JollyWorld Discord.","nl":"Zeg hallo in de JollyWorld-Discord.","de":"Sag Hallo im JollyWorld-Discord.","fr":"Dis bonjour sur le Discord de JollyWorld.","es":"Saluda en el Discord de JollyWorld.","pt":"Diz olá no Discord do JollyWorld.","it":"Saluta nel Discord di JollyWorld.","cz":"Pozdrav ostatní na JollyWorld Discordu.","jp":"JollyWorld Discordであいさつしよう。","ru":"Поздоровайтесь в Discord JollyWorld.","jr":"Say ahoy in the JollyWorld Discord."},
    {"textId":"discord_backtogame","us":"Back to the game","nl":"Terug naar het spel","de":"Zurück zum Spiel","fr":"Retour au jeu","es":"Volver al juego","pt":"Voltar ao jogo","it":"Torna al gioco","cz":"Zpět do hry","jp":"ゲームに戻る","ru":"Вернуться в игру","jr":"Back to the seas"},
    {"textId":"discord_failed_title","us":"We couldn't add you automatically","nl":"We konden je niet automatisch toevoegen","de":"Wir konnten dich nicht automatisch hinzufügen","fr":"Impossible de t’ajouter automatiquement","es":"No hemos podido añadirte automáticamente","pt":"Não conseguimos adicionar-te automaticamente","it":"Non siamo riusciti ad aggiungerti automaticamente","cz":"Nepodařilo se tě přidat automaticky","jp":"自動で参加できませんでした","ru":"Не удалось добавить вас автоматически","jr":"We couldn't haul ye aboard"},
    {"textId":"discord_failed_body","us":"You can still join with the invite link. Your role is added as soon as you're in.","nl":"Je kunt nog steeds meedoen via de uitnodigingslink. Je rol wordt toegevoegd zodra je binnen bent.","de":"Du kannst trotzdem über den Einladungslink beitreten. Deine Rolle kommt dazu, sobald du drin bist.","fr":"Tu peux quand même rejoindre avec le lien d’invitation. Ton rôle sera ajouté dès ton arrivée.","es":"Aún puedes unirte con el enlace de invitación. Tu rol se añadirá en cuanto entres.","pt":"Ainda podes entrar com o link de convite. O teu cargo é adicionado assim que entrares.","it":"Puoi comunque entrare con il link d’invito. Il tuo ruolo verrà aggiunto appena entri.","cz":"Pořád se můžeš připojit přes pozvánku. Roli dostaneš hned, jak tam budeš.","jp":"招待リンクから参加できます。参加するとすぐにロールが付きます。","ru":"Вы всё ещё можете войти по ссылке-приглашению. Роль добавится, как только вы присоединитесь.","jr":"Ye can still board with the invite link. Yer role gets added once ye be in."},
    {"textId":"discord_invite","us":"Use invite link","nl":"Uitnodigingslink gebruiken","de":"Einladungslink nutzen","fr":"Utiliser le lien d’invitation","es":"Usar el enlace de invitación","pt":"Usar o link de convite","it":"Usa il link d’invito","cz":"Použít pozvánku","jp":"招待リンクを使う","ru":"Открыть приглашение","jr":"Use the invite link"},
    {"textId":"server_down_title","us":"JollyWorld is down","nl":"JollyWorld is offline","de":"JollyWorld ist down","fr":"JollyWorld est hors service","es":"JollyWorld no funciona","pt":"O JollyWorld está em baixo","it":"JollyWorld non è disponibile","cz":"JollyWorld nefunguje","jp":"JollyWorldは現在ダウンしています","ru":"JollyWorld не работает","jr":"JollyWorld be sunk"},
    {"textId":"server_down_body","us":"We can't reach the JollyWorld servers right now, so levels, logins and leaderboards won't load. We're working on it.","nl":"We kunnen de JollyWorld-servers nu niet bereiken, dus levels, inloggen en ranglijsten laden niet. We zijn ermee bezig.","de":"Wir erreichen die JollyWorld-Server gerade nicht, deshalb laden Level, Anmeldung und Bestenlisten nicht. Wir arbeiten daran.","fr":"Impossible de joindre les serveurs de JollyWorld pour le moment : les niveaux, la connexion et les classements ne se chargent pas. Nous nous en occupons.","es":"Ahora mismo no podemos conectar con los servidores de JollyWorld, así que los niveles, el inicio de sesión y las clasificaciones no cargan. Estamos en ello.","pt":"Neste momento não conseguimos chegar aos servidores do JollyWorld, por isso os níveis, o início de sessão e as classificações não carregam. Estamos a tratar disso.","it":"Al momento non riusciamo a raggiungere i server di JollyWorld, quindi livelli, accesso e classifiche non si caricano. Ci stiamo lavorando.","cz":"Teď se nemůžeme spojit se servery JollyWorld, takže se nenačtou levely, přihlášení ani žebříčky. Pracujeme na tom.","jp":"現在JollyWorldのサーバーに接続できないため、レベル、ログイン、ランキングを読み込めません。復旧作業中です。","ru":"Сейчас серверы JollyWorld недоступны, поэтому уровни, вход и таблицы лидеров не загружаются. Мы уже работаем над этим.","jr":"We can't reach the JollyWorld ships right now, so levels, loggin' in and leaderboards won't load. The crew be on it."},
    {"textId":"server_down_retry","us":"Try again","nl":"Opnieuw proberen","de":"Erneut versuchen","fr":"Réessayer","es":"Reintentar","pt":"Tentar novamente","it":"Riprova","cz":"Zkusit znovu","jp":"再試行","ru":"Повторить","jr":"Try again"},
    {"textId":"server_down_checking","us":"Checking…","nl":"Controleren…","de":"Wird geprüft…","fr":"Vérification…","es":"Comprobando…","pt":"A verificar…","it":"Verifica in corso…","cz":"Ověřuji…","jp":"確認中…","ru":"Проверяем…","jr":"Spyin' the horizon…"},
    {"textId":"server_down_discord","us":"Updates on Discord","nl":"Updates op Discord","de":"Updates auf Discord","fr":"Infos sur Discord","es":"Novedades en Discord","pt":"Novidades no Discord","it":"Aggiornamenti su Discord","cz":"Novinky na Discordu","jp":"Discordで最新情報","ru":"Новости в Discord","jr":"News on Discord"},
    {"textId":"server_down_note","us":"We keep checking and close this as soon as we're back.","nl":"We blijven controleren en sluiten dit zodra we terug zijn.","de":"Wir prüfen weiter und schließen das, sobald wir wieder da sind.","fr":"Nous vérifions régulièrement et fermerons ce message dès notre retour.","es":"Seguiremos comprobando y cerraremos esto en cuanto volvamos.","pt":"Continuamos a verificar e fechamos isto assim que voltarmos.","it":"Continuiamo a controllare e chiuderemo questo messaggio appena torniamo.","cz":"Budeme to dál zkoušet a jakmile budeme zpět, tohle se zavře.","jp":"自動で確認を続け、復旧したらこの画面を閉じます。","ru":"Мы продолжаем проверять и закроем это окно, как только всё заработает.","jr":"We keep a lookout and close this once we be back."},
    {"textId":"levelbanner_comments","us":"Comments","nl":"Reacties","de":"Kommentare","fr":"Commentaires","es":"Comentarios","pt":"Comentários","it":"Commenti","cz":"Komentáře","jp":"コメント","ru":"Комментарии","jr":"Scuttlebutt"},
    {"textId":"comments_placeholder","us":"Write a comment…","nl":"Schrijf een reactie…","de":"Schreib einen Kommentar…","fr":"Écris un commentaire…","es":"Escribe un comentario…","pt":"Escreve um comentário…","it":"Scrivi un commento…","cz":"Napiš komentář…","jp":"コメントを書く…","ru":"Напишите комментарий…","jr":"Scribble yer words, matey…"},
    {"textId":"comments_post","us":"Post","nl":"Plaatsen","de":"Posten","fr":"Publier","es":"Publicar","pt":"Publicar","it":"Pubblica","cz":"Odeslat","jp":"投稿","ru":"Отправить","jr":"Send it!"},
    {"textId":"comments_login","us":"Log in to write a comment","nl":"Log in om een reactie te schrijven","de":"Melde dich an, um zu kommentieren","fr":"Connecte-toi pour commenter","es":"Inicia sesión para comentar","pt":"Inicia sessão para comentar","it":"Accedi per commentare","cz":"Přihlas se a napiš komentář","jp":"ログインしてコメントする","ru":"Войдите, чтобы оставить комментарий","jr":"Come aboard to leave yer mark"},
    {"textId":"comments_empty","us":"No comments yet. Be the first!","nl":"Nog geen reacties. Wees de eerste!","de":"Noch keine Kommentare. Sei der Erste!","fr":"Pas encore de commentaires. Sois le premier !","es":"Todavía no hay comentarios. ¡Sé el primero!","pt":"Ainda não há comentários. Sê o primeiro!","it":"Ancora nessun commento. Sii il primo!","cz":"Zatím žádné komentáře. Buď první!","jp":"まだコメントはありません。最初のコメントを書こう！","ru":"Комментариев пока нет. Будьте первым!","jr":"No words in the log yet. Be the first, matey!"},
    {"textId":"comments_loadmore","us":"Load more","nl":"Meer laden","de":"Mehr laden","fr":"Charger plus","es":"Cargar más","pt":"Carregar mais","it":"Carica altri","cz":"Načíst další","jp":"もっと見る","ru":"Показать ещё","jr":"Haul in more"},
    {"textId":"comments_delete","us":"Delete","nl":"Verwijderen","de":"Löschen","fr":"Supprimer","es":"Eliminar","pt":"Eliminar","it":"Elimina","cz":"Smazat","jp":"削除","ru":"Удалить","jr":"Scuttle"},
    {"textId":"comments_deletesure","us":"Sure?","nl":"Zeker?","de":"Sicher?","fr":"Sûr ?","es":"¿Seguro?","pt":"Tens a certeza?","it":"Sicuro?","cz":"Opravdu?","jp":"本当に？","ru":"Точно?","jr":"Aye?"},
    {"textId":"comments_error","us":"Something went wrong. Please try again.","nl":"Er ging iets mis. Probeer het opnieuw.","de":"Etwas ist schiefgelaufen. Bitte versuche es erneut.","fr":"Une erreur s'est produite. Veuillez réessayer.","es":"Algo ha salido mal. Inténtalo de nuevo.","pt":"Algo correu mal. Tenta novamente.","it":"Qualcosa è andato storto. Riprova.","cz":"Něco se pokazilo. Zkus to znovu.","jp":"問題が発生しました。もう一度お試しください。","ru":"Что-то пошло не так. Попробуйте ещё раз.","jr":"Blimey, something went wrong. Try again."},
    {"textId":"comments_toofast","us":"You're commenting too fast. Wait a moment and try again.","nl":"Je reageert te snel. Wacht even en probeer het opnieuw.","de":"Du kommentierst zu schnell. Warte kurz und versuche es erneut.","fr":"Tu commentes trop vite. Attends un instant et réessaie.","es":"Estás comentando demasiado rápido. Espera un momento y vuelve a intentarlo.","pt":"Estás a comentar demasiado depressa. Espera um momento e tenta novamente.","it":"Stai commentando troppo in fretta. Aspetta un attimo e riprova.","cz":"Komentuješ moc rychle. Chvíli počkej a zkus to znovu.","jp":"コメントの投稿が速すぎます。少し待ってからもう一度お試しください。","ru":"Вы комментируете слишком часто. Подождите немного и попробуйте снова.","jr":"Slow yer sails, matey! Wait a moment and try again."},
    {"textId":"replay_title","us":"Replay","nl":"Herhaling","de":"Wiederholung","fr":"Rediffusion","es":"Repetición","pt":"Repetição","it":"Replay","cz":"Záznam","jp":"リプレイ","ru":"Повтор","jr":"Ye olde replay"},
    {"textId":"replay_watching","us":"Watching {name}","nl":"Je kijkt naar {name}","de":"Du schaust {name} zu","fr":"Vous regardez {name}","es":"Viendo a {name}","pt":"A ver {name}","it":"Stai guardando {name}","cz":"Sleduješ hráče {name}","jp":"{name}を観戦中","ru":"Вы смотрите: {name}","jr":"Spyin' on {name}"},
    {"textId":"replay_attempt","us":"Attempt {current}/{total}","nl":"Poging {current}/{total}","de":"Versuch {current}/{total}","fr":"Essai {current}/{total}","es":"Intento {current}/{total}","pt":"Tentativa {current}/{total}","it":"Tentativo {current}/{total}","cz":"Pokus {current}/{total}","jp":"{current}/{total}回目","ru":"Попытка {current}/{total}","jr":"Voyage {current}/{total}"},
    {"textId":"replay_out_of_sync","us":"Out of sync","nl":"Niet meer synchroon","de":"Nicht mehr synchron","fr":"Désynchronisée","es":"Desincronizada","pt":"Dessincronizada","it":"Fuori sincrono","cz":"Rozsynchronizováno","jp":"同期ずれ","ru":"Рассинхронизация","jr":"Lost at sea"},
    {"textId":"replay_play","us":"Play","nl":"Afspelen","de":"Abspielen","fr":"Lecture","es":"Reproducir","pt":"Reproduzir","it":"Riproduci","cz":"Přehrát","jp":"再生","ru":"Воспроизвести","jr":"Set sail"},
    {"textId":"replay_pause","us":"Pause","nl":"Pauzeren","de":"Pausieren","fr":"Pause","es":"Pausar","pt":"Pausar","it":"Pausa","cz":"Pozastavit","jp":"一時停止","ru":"Пауза","jr":"Drop anchor"},
    {"textId":"replay_restart","us":"Watch again","nl":"Opnieuw bekijken","de":"Nochmal ansehen","fr":"Revoir","es":"Ver de nuevo","pt":"Ver de novo","it":"Guarda di nuovo","cz":"Přehrát znovu","jp":"最初から見る","ru":"Смотреть заново","jr":"Sail it again"},
    {"textId":"replay_slower","us":"Slower","nl":"Langzamer","de":"Langsamer","fr":"Plus lent","es":"Más lento","pt":"Mais lento","it":"Più lento","cz":"Pomaleji","jp":"遅く","ru":"Медленнее","jr":"Slower, matey"},
    {"textId":"replay_faster","us":"Faster","nl":"Sneller","de":"Schneller","fr":"Plus rapide","es":"Más rápido","pt":"Mais rápido","it":"Più veloce","cz":"Rychleji","jp":"速く","ru":"Быстрее","jr":"Faster, matey"},
    {"textId":"replay_step","us":"Next frame","nl":"Volgend frame","de":"Nächstes Bild","fr":"Image suivante","es":"Siguiente fotograma","pt":"Fotograma seguinte","it":"Fotogramma successivo","cz":"Další snímek","jp":"コマ送り","ru":"Следующий кадр","jr":"Next heartbeat"},
    {"textId":"replay_copy_link","us":"Copy replay link","nl":"Replaylink kopiëren","de":"Replay-Link kopieren","fr":"Copier le lien de la rediffusion","es":"Copiar enlace de la repetición","pt":"Copiar ligação da repetição","it":"Copia link del replay","cz":"Kopírovat odkaz na záznam","jp":"リプレイのリンクをコピー","ru":"Скопировать ссылку на повтор","jr":"Copy the treasure map"},
    {"textId":"replay_exit","us":"Stop watching","nl":"Stoppen met kijken","de":"Zuschauen beenden","fr":"Arrêter de regarder","es":"Dejar de ver","pt":"Parar de ver","it":"Smetti di guardare","cz":"Přestat sledovat","jp":"観戦をやめる","ru":"Закончить просмотр","jr":"Abandon ship"},
    {"textId":"replay_watch","us":"Watch replay","nl":"Herhaling bekijken","de":"Wiederholung ansehen","fr":"Voir la rediffusion","es":"Ver repetición","pt":"Ver repetição","it":"Guarda il replay","cz":"Přehrát záznam","jp":"リプレイを見る","ru":"Смотреть повтор","jr":"Watch yer voyage"},
    {"textId":"replay_share","us":"Share replay","nl":"Herhaling delen","de":"Wiederholung teilen","fr":"Partager la rediffusion","es":"Compartir repetición","pt":"Partilhar repetição","it":"Condividi il replay","cz":"Sdílet záznam","jp":"リプレイを共有","ru":"Поделиться повтором","jr":"Share yer voyage"},
    {"textId":"replay_finished","us":"Finished in {time}","nl":"Gefinisht in {time}","de":"Ins Ziel in {time}","fr":"Terminé en {time}","es":"Terminado en {time}","pt":"Terminado em {time}","it":"Finito in {time}","cz":"Dokončeno za {time}","jp":"{time}でゴール","ru":"Финиш за {time}","jr":"Made port in {time}"},
    {"textId":"replay_play_level","us":"Play this level","nl":"Speel dit level","de":"Dieses Level spielen","fr":"Jouer ce niveau","es":"Jugar este nivel","pt":"Jogar este nível","it":"Gioca questo livello","cz":"Hrát tuto úroveň","jp":"このレベルをプレイ","ru":"Играть в этот уровень","jr":"Sail this island"},
    {"textId":"replay_sound","us":"Tap for sound","nl":"Tik voor geluid","de":"Tippen für Ton","fr":"Touchez pour le son","es":"Toca para activar el sonido","pt":"Toque para ativar o som","it":"Tocca per l'audio","cz":"Klepněte pro zvuk","jp":"タップでサウンドON","ru":"Нажмите для звука","jr":"Tap fer a sea shanty"},
    {"textId":"replay_make_video","us":"Make a video","nl":"Maak een video","de":"Video erstellen","fr":"Créer une vidéo","es":"Crear un vídeo","pt":"Criar um vídeo","it":"Crea un video","cz":"Vytvořit video","jp":"動画を作成","ru":"Создать видео","jr":"Paint a movin' picture"},
    {
        "textId": "mainmenu_singleplayer",
        "us": "Single Player",
        "nl": "Eén speler",
        "de": "Einzelspieler",
        "es": "Un solo jugador",
        "pt": "Um jogador",
        "cz": "Jeden hráč",
        "fr": "Solo",
        "it": "Giocatore singolo",
        "jr": "Solo voyage",
        "jp": "シングルプレイ",
        "ru": "Одиночная игра"
    },
    {
        "textId": "mainmenu_multiplayer",
        "us": "Multiplayer",
        "nl": "Multiplayer",
        "de": "Multiplayer",
        "es": "Multijugador",
        "pt": "Multijogador",
        "cz": "Multiplayer",
        "fr": "Multijoueur",
        "it": "Multiplayer",
        "jr": "Play in a crew",
        "jp": "マルチプレイ",
        "ru": "Мультиплеер"
    },
    {
        "textId": "mainmenu_creategame",
        "us": "Create Game",
        "nl": "Spel maken",
        "de": "Spiel erstellen",
        "es": "Crear juego",
        "pt": "Criar jogo",
        "cz": "Vytvořit hru",
        "fr": "Créer une partie",
        "it": "Crea gioco",
        "jr": "Start a voyage",
        "jp": "ゲームを作成",
        "ru": "Создать игру"
    },
    {
        "textId": "mainmenu_changelevel",
        "us": "Change",
        "nl": "Wijzigen",
        "de": "Ändern",
        "es": "Cambiar",
        "pt": "Alterar",
        "cz": "Změnit",
        "fr": "Changer",
        "it": "Cambia",
        "jp": "変更",
        "ru": "Изменить",
        "jr": "Change course"
    },
    {
        "textId": "mainmenu_selectlevel",
        "us": "Select Level",
        "nl": "Level kiezen",
        "de": "Level auswählen",
        "es": "Seleccionar nivel",
        "pt": "Selecionar nível",
        "cz": "Vybrat úroveň",
        "fr": "Choisir le niveau",
        "it": "Seleziona livello",
        "jr": "Pick an island",
        "jp": "レベルを選択",
        "ru": "Выбрать уровень"
    },
    {
        "textId": "mainmenu_players",
        "us": "Players",
        "nl": "Spelers",
        "de": "Spieler",
        "es": "Jugadores",
        "pt": "Jogadores",
        "cz": "Hráči",
        "fr": "Joueurs",
        "it": "Giocatori",
        "jr": "Mates",
        "jp": "プレイヤー",
        "ru": "Игроки"
    },
    {
        "textId": "mainmenu_nolevel",
        "us": "Admin is selecting level",
        "nl": "De beheerder kiest een level",
        "de": "Der Admin wählt ein Level aus",
        "es": "El administrador está seleccionando el nivel",
        "pt": "O administrador está a escolher um nível",
        "cz": "Admin vybírá úroveň",
        "fr": "L'administrateur sélectionne le niveau",
        "it": "L'amministratore sta selezionando il livello",
        "jr": "The captain be pickin’ a level",
        "jp": "管理者がレベルを選択中",
        "ru": "Админ выбирает уровень"
    },
    {
        "textId": "mainmenu_ready",
        "us": "Ready",
        "nl": "Gereed",
        "de": "Bereit",
        "es": "Listo",
        "pt": "Pronto",
        "cz": "Připraven",
        "fr": "Prêt",
        "it": "Pronto",
        "jp": "準備完了",
        "ru": "Готово",
        "jr": "Ready, aye!"
    },
    {
        "textId": "mainmenu_start",
        "us": "Start",
        "nl": "Start",
        "de": "Starten",
        "es": "Iniciar",
        "pt": "Começar",
        "cz": "Start",
        "fr": "Commencer",
        "it": "Avvia",
        "jp": "スタート",
        "ru": "Начать",
        "jr": "Set sail"
    },
    {
        "textId": "mainmenu_admin",
        "us": "Admin",
        "nl": "Beheerder",
        "de": "Administrator",
        "es": "Administrador",
        "pt": "Administrador",
        "cz": "Admin",
        "fr": "Administrateur",
        "it": "Amministratore",
        "jr": "Captain",
        "jp": "管理者",
        "ru": "Администратор"
    },
    {
        "textId": "mainmenu_connecting",
        "us": "Connecting",
        "nl": "Verbinding maken…",
        "de": "Verbindung wird hergestellt…",
        "es": "Conectando…",
        "pt": "A ligar…",
        "cz": "Připojování…",
        "fr": "Connexion en cours…",
        "it": "Connessione in corso…",
        "jr": "Boardin' ship",
        "jp": "接続中…",
        "ru": "Подключение…"
    },
    {
        "textId": "mainmenu_waiting",
        "us": "Waiting",
        "nl": "Wachten…",
        "de": "Warten…",
        "es": "Esperando",
        "pt": "À espera…",
        "cz": "Čekání",
        "fr": "En attente…",
        "it": "In attesa",
        "jr": "Waitin'",
        "jp": "待機中",
        "ru": "В ожидании"
    },
    {
        "textId": "mainmenu_kick",
        "us": "Kick",
        "nl": "Verwijderen",
        "de": "Entfernen",
        "es": "Expulsar",
        "pt": "Expulsar",
        "cz": "Vyhodit",
        "fr": "Expulser",
        "it": "Espelli",
        "jr": "Throw overboard",
        "jp": "退出させる",
        "ru": "Выгнать"
    },
    {
        "textId": "mainmenu_leave",
        "us": "Leave",
        "nl": "Verlaten",
        "de": "Verlassen",
        "es": "Abandonar",
        "pt": "Sair",
        "cz": "Odejít",
        "fr": "Quitter",
        "it": "Esci",
        "jr": "Leave the crew",
        "jp": "退出",
        "ru": "Покинуть игру"
    },
    {
        "textId": "mainmenu_quickplay",
        "us": "Quick Play",
        "nl": "Snel spelen",
        "de": "Schnelles Spiel",
        "es": "Partida rápida",
        "pt": "Partida rápida",
        "cz": "Rychlá hra",
        "fr": "Partie rapide",
        "it": "Partita veloce",
        "jr": "Free sailin'",
        "jp": "クイックプレイ",
        "ru": "Быстрая игра"
    },
    {
        "textId": "mainmenu_createlevels",
        "us": "Create levels!",
        "nl": "Maak levels!",
        "de": "Level erstellen!",
        "es": "¡Crea niveles!",
        "pt": "Cria níveis!",
        "cz": "Vytvářej úrovně!",
        "fr": "Créez des niveaux !",
        "it": "Crea livelli!",
        "jr": "Build an island base",
        "jp": "レベルを作ろう！",
        "ru": "Создайте уровни!"
    },
    {
        "textId": "mainmenu_signup",
        "us": "Sign Up!",
        "nl": "Registreren!",
        "de": "Registrieren!",
        "es": "¡Regístrate!",
        "pt": "Regista-te!",
        "cz": "Zaregistrovat se!",
        "fr": "Inscrivez-vous !",
        "it": "Registrati!",
        "jp": "アカウント作成",
        "ru": "Зарегистрироваться!",
        "jr": "Join the crew!"
    },
    {
        "textId": "mainmenu_characters",
        "us": "Characters",
        "nl": "Personages",
        "de": "Charaktere",
        "es": "Personajes",
        "pt": "Personagens",
        "cz": "Postavy",
        "fr": "Personnages",
        "it": "Personaggi",
        "jr": "Buccaneers",
        "jp": "キャラクター",
        "ru": "Персонажи"
    },
    {
        "textId": "mainmenu_onlyfeatured",
        "us": "Only Featured",
        "nl": "Alleen aanbevolen",
        "de": "Nur Empfohlene",
        "es": "Solo destacados",
        "pt": "Apenas em destaque",
        "cz": "Pouze doporučené",
        "fr": "Recommandés uniquement",
        "it": "Solo in evidenza",
        "jr": "Captain’s picks only",
        "jp": "おすすめのみ",
        "ru": "Только рекомендованные"
    },
    {
        "textId": "mainmenu_promoted",
        "us": "Promoted",
        "nl": "Gepromoot",
        "de": "Hervorgehoben",
        "es": "Promocionado",
        "pt": "Promovido",
        "cz": "Propagováno",
        "fr": "Mis en avant",
        "it": "In vetrina",
        "jr": "Hoisted high",
        "jp": "注目",
        "ru": "Промо"
    },
    {
        "textId": "mainmenu_sorted",
        "us": "Sorted By:",
        "nl": "Sorteren op:",
        "de": "Sortiert nach:",
        "es": "Ordenar por:",
        "pt": "Ordenar por:",
        "cz": "Seřadit podle:",
        "fr": "Trier par :",
        "it": "Ordina per:",
        "jr": "Sort the chart by:",
        "jp": "並べ替え:",
        "ru": "Сортировать по:"
    },
    {
        "textId": "mainmenu_filters",
        "us": "Filters",
        "nl": "Filters",
        "de": "Filter",
        "es": "Filtros",
        "pt": "Filtros",
        "cz": "Filtry",
        "fr": "Filtres",
        "it": "Filtri",
        "jp": "フィルター",
        "ru": "Фильтры",
        "jr": "Chart filters"
    },
    {
        "textId": "mainmenu_allvehicles",
        "us": "All Vehicles",
        "nl": "Alle voertuigen",
        "de": "Alle Fahrzeuge",
        "es": "Todos los vehículos",
        "pt": "Todos os veículos",
        "cz": "Všechna vozidla",
        "fr": "Tous les véhicules",
        "it": "Tutti i veicoli",
        "jr": "All ships",
        "jp": "すべての乗り物",
        "ru": "Весь транспорт"
    },
    {
        "textId": "mainmenu_best_rated",
        "us": "Best Rated",
        "nl": "Best beoordeeld",
        "de": "Am besten bewertet",
        "es": "Mejor valorados",
        "pt": "Mais bem avaliados",
        "cz": "Nejlépe hodnocené",
        "fr": "Les mieux notés",
        "it": "Valutazione più alta",
        "jr": "Most Bootyful",
        "jp": "評価が高い順",
        "ru": "С лучшими оценками"
    },
    {
        "textId": "mainmenu_most_played",
        "us": "Most Played",
        "nl": "Meest gespeeld",
        "de": "Meistgespielt",
        "es": "Más jugados",
        "pt": "Mais jogados",
        "cz": "Nejhranější",
        "fr": "Les plus joués",
        "it": "Più giocati",
        "jr": "Most Plundered",
        "jp": "プレイ回数が多い順",
        "ru": "Чаще всего играют"
    },
    {
        "textId": "mainmenu_newest",
        "us": "Newest",
        "nl": "Nieuwste",
        "de": "Neueste",
        "es": "Más recientes",
        "pt": "Mais recentes",
        "cz": "Nejnovější",
        "fr": "Les plus récents",
        "it": "Più recenti",
        "jr": "Newly Discovered",
        "jp": "新しい順",
        "ru": "Самые новые"
    },
    {
        "textId": "mainmenu_oldest",
        "us": "Oldest",
        "nl": "Oudste",
        "de": "Älteste",
        "es": "Más antiguos",
        "pt": "Mais antigos",
        "cz": "Nejstarší",
        "fr": "Les plus anciens",
        "it": "Meno recenti",
        "jr": "Ol' sea legends",
        "jp": "古い順",
        "ru": "Самые старые"
    },
    {
        "textId": "mainmenu_recently",
        "us": "Recently Played",
        "nl": "Recent gespeeld",
        "de": "Kürzlich gespielt",
        "es": "Jugados recientemente",
        "pt": "Jogados recentemente",
        "cz": "Nedávno hrané",
        "fr": "Joués récemment",
        "it": "Giocati di recente",
        "jr": "Recently sailed",
        "jp": "最近プレイしたレベル",
        "ru": "Недавно сыгранные"
    },
    {
        "textId": "mainmenu_editor",
        "us": "Editor",
        "nl": "Editor",
        "de": "Editor",
        "es": "Editor",
        "pt": "Editor",
        "cz": "Editor",
        "fr": "Éditeur",
        "it": "Editor",
        "jr": "Sea Buildin'",
        "jp": "エディター",
        "ru": "Редактор"
    },
    {
        "textId": "mainmenu_by",
        "us": "By",
        "nl": "Door",
        "de": "Von",
        "es": "De",
        "pt": "De",
        "cz": "Od",
        "fr": "Par",
        "it": "Da",
        "jr": "Made by",
        "jp": "作者",
        "ru": "Автор"
    },
    {
        "textId": "mainmenu_login",
        "us": "login",
        "nl": "inloggen",
        "de": "einloggen",
        "es": "Entrar",
        "pt": "Entrar",
        "cz": "Přihlásit se",
        "fr": "Se connecter",
        "it": "Entra",
        "jr": "Sign aboard",
        "jp": "サインイン",
        "ru": "Войти"
    },
    {
        "textId": "mainmenu_today",
        "us": "Today",
        "nl": "Vandaag",
        "de": "Heute",
        "es": "Hoy",
        "pt": "Hoje",
        "cz": "Dnes",
        "fr": "Aujourd'hui",
        "it": "Oggi",
        "jr": "Since this day",
        "jp": "今日",
        "ru": "Сегодня"
    },
    {
        "textId": "mainmenu_thisweek",
        "us": "This Week",
        "nl": "Deze week",
        "de": "Diese Woche",
        "es": "Esta semana",
        "pt": "Esta semana",
        "cz": "Tento týden",
        "fr": "Cette semaine",
        "it": "Questa settimana",
        "jr": "This week at sea",
        "jp": "今週",
        "ru": "За эту неделю"
    },
    {
        "textId": "mainmenu_thismonth",
        "us": "This Month",
        "nl": "Deze maand",
        "de": "Diesen Monat",
        "es": "Este mes",
        "pt": "Este mês",
        "cz": "Tento měsíc",
        "fr": "Ce mois-ci",
        "it": "Questo mese",
        "jr": "This month at sea",
        "jp": "今月",
        "ru": "За этот месяц"
    },
    {
        "textId": "mainmenu_anytime",
        "us": "All Time",
        "nl": "Alle periodes",
        "de": "Gesamter Zeitraum",
        "es": "Todo el tiempo",
        "pt": "Todo o período",
        "cz": "Za celou dobu",
        "fr": "Toutes les périodes",
        "it": "Tutto il periodo",
        "jr": "Since forever!",
        "jp": "全期間",
        "ru": "За все время"
    },
    {
        "textId": "mainmenu_more",
        "us": "More",
        "nl": "Meer",
        "de": "Mehr",
        "es": "Más",
        "pt": "Mais",
        "cz": "Více",
        "fr": "Plus",
        "it": "Di più",
        "jr": "Moarrgh",
        "jp": "もっと見る",
        "ru": "Ещё"
    },
    {
        "textId": "mainmenu_availablepc",
        "us": "Available on PC",
        "nl": "Beschikbaar op pc",
        "de": "Auf PC verfügbar",
        "es": "Disponible en PC",
        "pt": "Disponível no PC",
        "cz": "K dispozici na PC",
        "fr": "Disponible sur PC",
        "it": "Disponibile su PC",
        "jr": "Available on PC, matey",
        "jp": "PCで利用可能",
        "ru": "Доступно на ПК"
    },
    {
        "textId": "settings_settings",
        "us": "Settings",
        "nl": "Instellingen",
        "de": "Einstellungen",
        "es": "Ajustes",
        "pt": "Definições",
        "cz": "Nastavení",
        "fr": "Paramètres",
        "it": "Impostazioni",
        "jr": "Mess with yer boat",
        "jp": "設定",
        "ru": "Настройки"
    },
    {
        "textId": "settings_on",
        "us": "on",
        "nl": "aan",
        "de": "ein",
        "es": "Activado",
        "pt": "Ligado",
        "cz": "Zapnuto",
        "fr": "Activé",
        "it": "Attivato",
        "jr": "Aye",
        "jp": "オン",
        "ru": "Вкл."
    },
    {
        "textId": "settings_off",
        "us": "off",
        "nl": "uit",
        "de": "aus",
        "es": "Desactivado",
        "pt": "Desligado",
        "cz": "Vypnuto",
        "fr": "Désactivé",
        "it": "Disattivato",
        "jr": "Nay",
        "jp": "オフ",
        "ru": "Выкл."
    },
    {
        "textId": "settings_music",
        "us": "Music",
        "nl": "Muziek",
        "de": "Musik",
        "es": "Música",
        "pt": "Música",
        "cz": "Hudba",
        "fr": "Musique",
        "it": "Musica",
        "jr": "Shanties",
        "jp": "音楽",
        "ru": "Музыка"
    },
    {
        "textId": "settings_vocals",
        "us": "Vocals",
        "nl": "Stemmen",
        "de": "Stimmen",
        "es": "Voces",
        "pt": "Vozes",
        "cz": "Hlasy",
        "fr": "Voix",
        "it": "Voci",
        "jr": "Crew chatter",
        "jp": "キャラクターの声",
        "ru": "Голоса"
    },
    {
        "textId": "settings_blood",
        "us": "Blood",
        "nl": "Bloed",
        "de": "Blut",
        "es": "Sangre",
        "pt": "Sangue",
        "cz": "Krev",
        "fr": "Sang",
        "it": "Sangue",
        "jr": "Juice",
        "jp": "血",
        "ru": "Кровь"
    },
    {
        "textId": "settings_hd",
        "us": "HD",
        "de": "HD",
        "jp": "HD",
        "pt": "HD",
        "fr": "HD",
        "es": "HD",
        "it": "HD",
        "nl": "HD",
        "ru": "HD",
        "cz": "HD",
        "jr": "HD"
    },
    {
        "textId": "settings_fullscreen",
        "us": "Fullscreen",
        "nl": "Volledig scherm",
        "de": "Vollbild",
        "es": "Pantalla completa",
        "pt": "Ecrã inteiro",
        "cz": "Celá obrazovka",
        "fr": "Plein écran",
        "it": "Schermo intero",
        "jr": "Fill yer screen",
        "jp": "全画面表示",
        "ru": "Полный экран"
    },
    {
        "textId": "settings_consent",
        "us": "Cookies",
        "jr": "Cookies, matey",
        "jp": "Cookie",
        "ru": "Файлы cookie",
        "de": "Cookies",
        "pt": "Cookies",
        "fr": "Cookies",
        "es": "Cookies",
        "it": "Cookies",
        "nl": "Cookies",
        "cz": "Cookies"
    },
    {
        "textId": "settings_credits",
        "us": "Credits",
        "nl": "Credits",
        "de": "Mitwirkende",
        "es": "Créditos",
        "pt": "Créditos",
        "cz": "Autoři",
        "fr": "Crédits",
        "it": "Crediti",
        "jr": "Crewmates",
        "jp": "クレジット",
        "ru": "Авторы"
    },
    {
        "textId": "settings_installedmod",
        "us": "Mod active",
        "nl": "Mod actief",
        "de": "Aktive Mod",
        "es": "Mod activo",
        "pt": "Mod ativo",
        "cz": "Aktivní mod",
        "fr": "Mod actif",
        "it": "Mod attivo",
        "jr": "Mod aboard",
        "jp": "使用中のMOD",
        "ru": "Активный мод"
    },
    {
        "textId": "settings_installmod",
        "us": "Modify",
        "nl": "Aanpassen",
        "de": "Modifizieren",
        "es": "Modificar",
        "pt": "Modificar",
        "cz": "Modifikovat",
        "fr": "Modifier",
        "it": "Modifica",
        "jr": "Decorate yer ship",
        "jp": "カスタマイズ",
        "ru": "Изменить"
    },
    {
        "textId": "settings_none",
        "us": "None",
        "nl": "Geen",
        "de": "Keine",
        "es": "Ninguno",
        "pt": "Nenhum",
        "cz": "Žádný",
        "fr": "Aucun",
        "it": "Nessuno",
        "jr": "Nay",
        "jp": "なし",
        "ru": "Нет"
    },
    {
        "textId": "characterselect_select_character",
        "us": "Select a character",
        "nl": "Kies een personage",
        "de": "Wähle einen Charakter",
        "es": "Seleccionar personaje",
        "pt": "Selecionar personagem",
        "cz": "Vybrat postavu",
        "fr": "Choisir un personnage",
        "it": "Seleziona personaggio",
        "jr": "Pick yer captain",
        "jp": "キャラクターを選択",
        "ru": "Выбрать персонажа"
    },
    {
        "textId": "vehicleselect_select_vehicle",
        "us": "Select a vehicle",
        "nl": "Kies een voertuig",
        "de": "Wähle ein Fahrzeug",
        "es": "Seleccionar vehículo",
        "pt": "Selecionar veículo",
        "cz": "Vybrat vozidlo",
        "fr": "Choisir un véhicule",
        "it": "Scegli un veicolo",
        "jr": "Pick yer boat",
        "jp": "乗り物を選択",
        "ru": "Выбрать транспорт"
    },
    {
        "textId": "levelbanner_share",
        "us": "Share",
        "nl": "Delen",
        "de": "Teilen",
        "es": "Compartir",
        "pt": "Partilhar",
        "cz": "Sdílet",
        "fr": "Partager",
        "it": "Condividi",
        "jr": "Share with yer maties",
        "jp": "共有",
        "ru": "Поделиться"
    },
    {
        "textId": "levelbanner_favorite",
        "us": "Favorite",
        "nl": "Favoriet",
        "de": "Favorit",
        "es": "Favorito",
        "pt": "Favorito",
        "cz": "Oblíbené",
        "fr": "Favori",
        "it": "Preferito",
        "jr": "Treasure",
        "jp": "お気に入り登録",
        "ru": "В избранное"
    },
    {
        "textId": "levelbanner_gameplays",
        "us": "Gameplays",
        "nl": "Gespeeld",
        "de": "Gespielt",
        "es": "Jugadas",
        "pt": "Jogadas",
        "cz": "Počet odehrání",
        "fr": "Parties jouées",
        "it": "Partite giocate",
        "jr": "Voyages",
        "jp": "プレイ回数",
        "ru": "Число запусков"
    },
    {
        "textId": "levelbanner_votes",
        "us": "Votes",
        "nl": "Stemmen",
        "de": "Stimmen",
        "es": "Votos",
        "pt": "Votos",
        "cz": "Hlasy",
        "fr": "Votes",
        "it": "Voti",
        "jr": "Ayes",
        "jp": "投票数",
        "ru": "Голоса"
    },
    {
        "textId": "levelbanner_viewall",
        "us": "View All",
        "nl": "Alles bekijken",
        "de": "Alle ansehen",
        "es": "Ver todos",
        "pt": "Ver todos",
        "cz": "Zobrazit vše",
        "fr": "Tout voir",
        "it": "Vedi tutto",
        "jr": "See it all, matey",
        "jp": "すべて表示",
        "ru": "Показать всё"
    },
    {
        "textId": "levelbanner_play",
        "us": "Play",
        "nl": "Spelen",
        "de": "Spielen",
        "es": "Jugar",
        "pt": "Jogar",
        "cz": "Hrát",
        "fr": "Jouer",
        "it": "Gioca",
        "jr": "Start the raid!",
        "jp": "プレイ",
        "ru": "Играть"
    },
    {
        "textId": "levelbanner_back",
        "us": "Back",
        "nl": "Terug",
        "de": "Zurück",
        "es": "Volver",
        "pt": "Voltar",
        "cz": "Zpět",
        "fr": "Retour",
        "it": "Indietro",
        "jr": "Back, matey",
        "jp": "戻る",
        "ru": "Назад"
    },
    {
        "textId": "levelbanner_leaderboard",
        "us": "Leaderboard",
        "nl": "Scorebord",
        "de": "Bestenliste",
        "es": "Clasificación",
        "pt": "Classificação",
        "cz": "Žebříček",
        "fr": "Classement",
        "it": "Classifica",
        "jr": "Most Wanted Pirates",
        "jp": "ランキング",
        "ru": "Таблица лидеров"
    },
    {
        "textId": "levelbanner_loading",
        "us": "Loading...",
        "nl": "Laden...",
        "de": "Laden...",
        "es": "Cargando…",
        "pt": "A carregar…",
        "cz": "Načítání…",
        "fr": "Chargement…",
        "it": "Caricamento…",
        "jr": "Sailin' to the destination",
        "jp": "読み込み中…",
        "ru": "Загрузка..."
    },
    {
        "textId": "levelbanner_time",
        "us": "Time",
        "nl": "Tijd",
        "de": "Zeit",
        "es": "Tiempo",
        "pt": "Tempo",
        "cz": "Čas",
        "fr": "Temps",
        "it": "Tempo",
        "jr": "Time at sea",
        "jp": "時間",
        "ru": "Время"
    },
    {
        "textId": "levelbanner_published",
        "us": "Published",
        "nl": "Gepubliceerd",
        "de": "Veröffentlicht",
        "es": "Publicado",
        "pt": "Publicado",
        "cz": "Zveřejněno",
        "fr": "Publié",
        "it": "Pubblicato",
        "jr": "Discovered",
        "jp": "公開日",
        "ru": "Опубликовано"
    },
    {
        "textId": "levelbanner_updated",
        "us": "Updated",
        "nl": "Bijgewerkt",
        "de": "Aktualisiert",
        "es": "Actualizado",
        "pt": "Atualizado",
        "cz": "Aktualizováno",
        "fr": "Mis à jour",
        "it": "Aggiornato",
        "jr": "Revisited",
        "jp": "最終更新日",
        "ru": "Обновлено"
    },
    {
        "textId": "levelbanner_noentries",
        "us": "No entries",
        "nl": "Geen scores",
        "de": "Keine Einträge",
        "es": "No hay registros",
        "pt": "Sem registos",
        "cz": "Žádné záznamy",
        "fr": "Aucun score",
        "it": "Nessun risultato",
        "jr": "Treasure unclaimed",
        "jp": "スコアなし",
        "ru": "Нет результатов"
    },
    {
        "textId": "levelbanner_select",
        "us": "Select",
        "nl": "Selecteer",
        "de": "Auswählen",
        "es": "Seleccionar",
        "pt": "Selecionar",
        "cz": "Vybrat",
        "fr": "Sélectionner",
        "it": "Seleziona",
        "jr": "Pick",
        "jp": "選択",
        "ru": "Выбрать"
    },
    {
        "textId": "userpage_levelspublished",
        "us": "Levels Published",
        "nl": "Gepubliceerde levels",
        "de": "Level veröffentlicht",
        "es": "Niveles publicados",
        "pt": "Níveis publicados",
        "cz": "Zveřejněné úrovně",
        "fr": "Niveaux publiés",
        "it": "Livelli pubblicati",
        "jr": "Islands Mapped",
        "jp": "公開したレベル数",
        "ru": "Опубликованные уровни"
    },
    {
        "textId": "userpage_averagerating",
        "us": "Average Rating",
        "nl": "Gemiddelde beoordeling",
        "de": "Durchschnittliche Bewertung",
        "es": "Valoración media",
        "pt": "Pontuação média",
        "cz": "Průměrné hodnocení",
        "fr": "Note moyenne",
        "it": "Valutazione media",
        "jr": "Reputation",
        "jp": "平均評価",
        "ru": "Средний рейтинг"
    },
    {
        "textId": "userpage_levelsfeatured",
        "us": "Levels Featured",
        "nl": "Aanbevolen levels",
        "de": "Empfohlene Level",
        "es": "Niveles destacados",
        "pt": "Níveis em destaque",
        "cz": "Doporučené úrovně",
        "fr": "Niveaux recommandés",
        "it": "Livelli in evidenza",
        "jr": "Scurvy Approved Islands",
        "jp": "おすすめに選ばれたレベル数",
        "ru": "Рекомендованные уровни"
    },
    {
        "textId": "userpage_totalgameplays",
        "us": "Total Gameplays",
        "nl": "Totaal gespeeld",
        "de": "Insgesamt gespielt",
        "es": "Total de jugadas",
        "pt": "Total de partidas jogadas",
        "cz": "Hráno celkem",
        "fr": "Total des parties jouées",
        "it": "Partite giocate in totale",
        "jr": "Total Voyages",
        "jp": "総プレイ回数",
        "ru": "Всего запусков уровней"
    },
    {
        "textId": "userpage_levels",
        "us": "Levels",
        "nl": "Levels",
        "de": "Levels",
        "es": "Niveles",
        "pt": "Níveis",
        "cz": "Úrovně",
        "fr": "Niveaux",
        "it": "Livelli",
        "jr": "Islands",
        "jp": "レベル",
        "ru": "Уровни"
    },
    {
        "textId": "userpage_favorites",
        "us": "Favorites",
        "nl": "Favorieten",
        "de": "Favoriten",
        "es": "Favoritos",
        "pt": "Favoritos",
        "cz": "Oblíbené",
        "fr": "Favoris",
        "it": "Preferiti",
        "jr": "Treasured",
        "jp": "お気に入り",
        "ru": "Избранное"
    },
    {
        "textId": "userpage_membersince",
        "us": "Member since",
        "nl": "Lid sinds",
        "de": "Mitglied seit",
        "es": "Miembro desde",
        "pt": "Membro desde",
        "cz": "Členem od",
        "fr": "Membre depuis",
        "it": "Membro da",
        "jr": "Aboard since",
        "jp": "登録日",
        "ru": "Дата регистрации"
    },
    {
        "textId": "share_sharing",
        "us": "Sharing",
        "nl": "Delen",
        "de": "Teilen",
        "es": "Compartir",
        "pt": "Partilhar",
        "cz": "Sdílení",
        "fr": "Partage",
        "it": "Condivisione",
        "jr": "Share with yer mates.",
        "jp": "共有",
        "ru": "Поделиться"
    },
    {
        "textId": "share_levellink",
        "us": "Level link",
        "nl": "Levellink",
        "de": "Level-Link",
        "es": "Enlace del nivel",
        "pt": "Ligação do nível",
        "cz": "Odkaz na úroveň",
        "fr": "Lien du niveau",
        "it": "Link del livello",
        "jr": "Island coordinates",
        "jp": "レベルへのリンク",
        "ru": "Ссылка на уровень"
    },
    {
        "textId": "share_shareby",
        "us": "Or share by",
        "nl": "Of deel met",
        "de": "Oder teilen über",
        "es": "O compartir mediante",
        "pt": "Ou partilhar através de",
        "cz": "Nebo sdílet přes",
        "fr": "Ou partager via",
        "it": "Oppure condividi tramite",
        "jr": "Alternate routes",
        "jp": "または次の方法で共有",
        "ru": "Или поделиться через"
    },
    {
        "textId": "discord_getinvolved",
        "us": "Get Involved!",
        "nl": "Doe mee!",
        "de": "Mach mit!",
        "es": "¡Participa!",
        "pt": "Participa!",
        "cz": "Přidej se!",
        "fr": "Rejoignez-nous !",
        "it": "Partecipa!",
        "jr": "Join the tavern",
        "jp": "コミュニティに参加しよう！",
        "ru": "Присоединяйтесь!"
    },
    {
        "textId": "levelgui_pause",
        "us": "Pause",
        "nl": "Pauze",
        "de": "Pause",
        "es": "Pausa",
        "pt": "Pausa",
        "cz": "Pauza",
        "fr": "Pause",
        "it": "Pausa",
        "jr": "Stop the ship",
        "jp": "一時停止",
        "ru": "Пауза"
    },
    {
        "textId": "levelgui_resume",
        "us": "Resume",
        "nl": "Hervatten",
        "de": "Fortsetzen",
        "es": "Continuar",
        "pt": "Continuar",
        "cz": "Pokračovat",
        "fr": "Reprendre",
        "it": "Riprendi",
        "jr": "Continue fightin'",
        "jp": "再開",
        "ru": "Продолжить"
    },
    {
        "textId": "levelgui_reset",
        "us": "Reset",
        "nl": "Reset",
        "de": "Zurücksetzen",
        "es": "Reiniciar",
        "pt": "Reiniciar",
        "cz": "Restartovat",
        "fr": "Réinitialiser",
        "it": "Reimposta",
        "jr": "Reset the voyage",
        "jp": "リセット",
        "ru": "Сбросить"
    },
    {
        "textId": "levelgui_retry",
        "us": "Retry",
        "nl": "Opnieuw",
        "de": "Erneut versuchen",
        "es": "Reintentar",
        "pt": "Tentar de novo",
        "cz": "Opakovat",
        "fr": "Réessayer",
        "it": "Riprova",
        "jr": "Try again, matey",
        "jp": "再試行",
        "ru": "Повторить"
    },
    {
        "textId": "levelgui_exittest",
        "us": "Exit Test",
        "nl": "Test verlaten",
        "de": "Test verlassen",
        "es": "Salir de la prueba",
        "pt": "Sair do teste",
        "cz": "Opustit test",
        "fr": "Quitter le test",
        "it": "Esci dal test",
        "jr": "End the sea trial",
        "jp": "テスト終了",
        "ru": "Выйти из теста"
    },
    {
        "textId": "levelgui_youlose",
        "us": "You lose!",
        "nl": "Je hebt verloren!",
        "de": "Du hast verloren!",
        "es": "¡Has perdido!",
        "pt": "Perdeste!",
        "cz": "Prohrál jsi!",
        "fr": "Vous avez perdu !",
        "it": "Hai perso!",
        "jr": "Yer with Davy Jones!",
        "jp": "負けてしまった！",
        "ru": "Вы проиграли!"
    },
    {"textId":"end_tap_continue","us":"Tap to continue","nl":"Tik om verder te gaan","de":"Tippen zum Fortfahren","es":"Toca para continuar","pt":"Toca para continuar","cz":"Klepni a pokračuj","fr":"Touche pour continuer","it":"Tocca per continuare","jr":"Tap to carry on, matey","jp":"タップして続ける","ru":"Коснитесь, чтобы продолжить"},
    {"textId":"end_click_continue","us":"Click to continue","nl":"Klik om verder te gaan","de":"Klicken zum Fortfahren","es":"Haz clic para continuar","pt":"Clica para continuar","cz":"Klikni a pokračuj","fr":"Clique pour continuer","it":"Clicca per continuare","jr":"Click to carry on, matey","jp":"クリックして続ける","ru":"Щёлкните, чтобы продолжить"},
    {"textId":"end_click_key_continue","us":"Click or press {key} to continue","nl":"Klik of druk op {key} om verder te gaan","de":"Klicke oder drücke {key} zum Fortfahren","es":"Haz clic o pulsa {key} para continuar","pt":"Clica ou carrega em {key} para continuar","cz":"Klikni nebo stiskni {key} a pokračuj","fr":"Clique ou appuie sur {key} pour continuer","it":"Clicca o premi {key} per continuare","jr":"Click or smash {key} to carry on, matey","jp":"クリックまたは{key}で続ける","ru":"Щёлкните или нажмите {key}, чтобы продолжить"},
    {"textId":"end_press_continue","us":"Press {key} to continue","nl":"Druk op {key} om verder te gaan","de":"Drücke {key} zum Fortfahren","es":"Pulsa {key} para continuar","pt":"Carrega em {key} para continuar","cz":"Stiskni {key} a pokračuj","fr":"Appuie sur {key} pour continuer","it":"Premi {key} per continuare","jr":"Smash {key} to carry on, matey","jp":"{key}で続ける","ru":"Нажмите {key}, чтобы продолжить"},
    {
        "textId": "levelgui_youwin",
        "us": "You win!",
        "nl": "Je hebt gewonnen!",
        "de": "Du hast gewonnen!",
        "es": "¡Has ganado!",
        "pt": "Ganhaste!",
        "cz": "Vyhrál jsi!",
        "fr": "Vous avez gagné !",
        "it": "Hai vinto!",
        "jr": "Ye found the treasure!",
        "jp": "勝利！",
        "ru": "Вы победили!"
    },
    {
        "textId": "tutorial_skip_button",
        "us": "Skip",
        "nl": "Overslaan",
        "de": "Überspringen",
        "es": "Omitir",
        "pt": "Saltar",
        "cz": "Přeskočit",
        "fr": "Passer",
        "it": "Salta",
        "jr": "Nah",
        "jp": "スキップ",
        "ru": "Пропустить"
    },
    {
        "textId": "editorheader_exit",
        "us": "Exit",
        "nl": "Verlaten",
        "de": "Verlassen",
        "es": "Salir",
        "pt": "Sair",
        "cz": "Odejít",
        "fr": "Quitter",
        "it": "Esci",
        "jr": "Abandon",
        "jp": "終了",
        "ru": "Выйти"
    },
    {
        "textId": "editorheader_logout",
        "us": "LOGOUT",
        "nl": "UITLOGGEN",
        "de": "AUSLOGGEN",
        "es": "Cerrar sesión",
        "pt": "Terminar sessão",
        "cz": "Odhlásit se",
        "fr": "Se déconnecter",
        "it": "Disconnetti",
        "jr": "DROP ANCHOR",
        "jp": "ログアウト",
        "ru": "ВЫЙТИ"
    },
    {
        "textId": "multiplayer_vote",
        "us": "Vote",
        "nl": "Stem",
        "de": "Abstimmen",
        "es": "Votar",
        "pt": "Votar",
        "cz": "Hlasovat",
        "fr": "Voter",
        "it": "Vota",
        "jr": "Vote",
        "jp": "投票",
        "ru": "Проголосовать"
    },
    {
        "textId": "multiplayer_replay",
        "us": "Replay",
        "nl": "Opnieuw",
        "de": "Erneut spielen",
        "es": "Volver a jugar",
        "pt": "Jogar de novo",
        "cz": "Hrát znovu",
        "fr": "Rejouer",
        "it": "Rigioca",
        "jr": "Plunder again",
        "jp": "もう一度プレイ",
        "ru": "Сыграть снова"
    },
    {
        "textId": "multiplayer_gamefinished_client",
        "us": "Game finished, vote for next level",
        "nl": "Spel afgelopen, stem op het volgende level",
        "de": "Spiel beendet, stimme für das nächste Level ab",
        "es": "Partida terminada, vota por el siguiente nivel",
        "pt": "Jogo terminado, vota no próximo nível",
        "cz": "Hra skončila, hlasuj pro další úroveň",
        "fr": "Partie terminée, votez pour le prochain niveau",
        "it": "Il gioco è finito, vota per il livello successivo",
        "jr": "Voyage over, vote for the next level",
        "jp": "ゲーム終了。次のレベルに投票してください",
        "ru": "Игра закончена, проголосуйте за следующий уровень"
    },
    {
        "textId": "multiplayer_gamefinished_admin",
        "us": "Game finished, pick the next level",
        "nl": "Spel afgelopen, kies het volgende level",
        "de": "Spiel beendet, wähle das nächste Level",
        "es": "Partida terminada, elige el siguiente nivel",
        "pt": "Jogo terminado, escolhe o próximo nível",
        "cz": "Hra skončila, vyber další úroveň",
        "fr": "Partie terminée, choisissez le prochain niveau",
        "it": "Gioco finito, scegli il livello successivo",
        "jr": "Voyage over, pick the next level",
        "jp": "ゲーム終了。次のレベルを選んでください",
        "ru": "Игра закончена, выберите следующий уровень"
    },
    {
        "textId": "multiplayer_gameendssoon",
        "us": "Players finished, game is ending soon..",
        "nl": "Spelers zijn gefinisht, het spel eindigt zo…",
        "de": "Spieler sind im Ziel, das Spiel endet bald…",
        "es": "Algunos jugadores han terminado, la partida acabará pronto…",
        "pt": "Há jogadores que já terminaram, o jogo acaba em breve…",
        "cz": "Hráči dorazili do cíle, hra brzy skončí…",
        "fr": "Des joueurs ont terminé, la partie va bientôt se terminer…",
        "it": "Alcuni giocatori hanno finito, la partita terminerà presto…",
        "jr": "Pirates have finished, the voyage ends soon…",
        "jp": "ゴールしたプレイヤーがいます。ゲームはまもなく終了します…",
        "ru": "Игроки добрались до финиша, игра скоро закончится…"
    },
    {
        "textId": "multiplayer_countdown",
        "us": "Game ends in %%s",
        "nl": "Het spel eindigt over %% s",
        "de": "Das Spiel endet in %% s",
        "es": "La partida termina en %% s",
        "pt": "O jogo termina em %% s",
        "cz": "Hra skončí za %% s",
        "fr": "La partie se termine dans %% s",
        "it": "La partita termina tra %% s",
        "jp": "ゲーム終了まであと%%秒",
        "ru": "Игра закончится через %% с",
        "jr": "Voyage ends in %% s"
    },
    {
        "textId": "multiplayer_switchcamera",
        "us": "Switch Camera",
        "nl": "Camera wisselen",
        "de": "Kamera wechseln",
        "es": "Cambiar cámara",
        "pt": "Mudar câmara",
        "cz": "Přepnout kameru",
        "fr": "Changer de caméra",
        "it": "Cambia visuale",
        "jp": "カメラ切り替え",
        "ru": "Переключить камеру",
        "jr": "Switch spyglass view"
    },
    {
        "textId": "multiplayer_waitingforothers",
        "us": "Waiting for other players to finish",
        "nl": "Wachten tot andere spelers klaar zijn",
        "de": "Warten, bis die anderen Spieler im Ziel sind",
        "es": "Esperando que otros jugadores terminen",
        "pt": "À espera que os outros jogadores terminem",
        "cz": "Čekání, až ostatní hráči dokončí úroveň",
        "fr": "En attente de l’arrivée des autres joueurs",
        "it": "In attesa che gli altri giocatori finiscano",
        "jr": "Waitin' for other maties to catch up",
        "jp": "ほかのプレイヤーがゴールするのを待っています",
        "ru": "Ждём, пока остальные игроки доберутся до финиша"
    },
    {
        "textId": "multiplayer_startingin",
        "us": "Starting in %%..",
        "nl": "Start over %%…",
        "de": "Start in %%…",
        "es": "Empieza en %%…",
        "pt": "Começa em %%…",
        "cz": "Začínáme za %%…",
        "fr": "Début dans %%…",
        "it": "Inizio tra %%…",
        "jr": "Settin’ sail in %%…",
        "jp": "開始まであと%%…",
        "ru": "Начало через %%…"
    },
    {
        "textId": "multiplayer_voted",
        "us": "Voted",
        "nl": "Gestemd",
        "de": "Abgestimmt",
        "es": "Votado",
        "pt": "Votado",
        "cz": "Hlasoval",
        "fr": "Voté",
        "it": "Votato",
        "jp": "投票済み",
        "ru": "Проголосовал",
        "jr": "Vote cast, aye"
    },
    {
        "textId": "multiplayer_go",
        "us": "GO!!!",
        "nl": "START!!!",
        "de": "LOS!!!",
        "es": "¡¡¡VAMOS!!!",
        "pt": "VAI!!!",
        "cz": "START!!!",
        "fr": "PARTEZ !!!",
        "it": "VIA!!!",
        "jr": "SET SAIL!!!",
        "jp": "スタート！！！",
        "ru": "ВПЕРЁД!!!"
    },
    {
        "textId": "multiplayer_waitingplayers",
        "us": "Waiting for other players %% / **",
        "nl": "Wachten op andere spelers: %% / **",
        "de": "Warten auf andere Spieler %% / **",
        "es": "Esperando a otros jugadores %% / **",
        "pt": "À espera dos outros jogadores: %% / **",
        "cz": "Čekání na další hráče %% / **",
        "fr": "En attente d'autres joueurs %% / **",
        "it": "In attesa degli altri giocatori: %% / **",
        "jp": "ほかのプレイヤーを待っています %% / **",
        "ru": "В ожидании других игроков %% / **",
        "jr": "Waitin’ for the crew: %% / **"
    },
    {
        "textId": "multiplayer_returntolobby",
        "us": "Return to Lobby",
        "nl": "Keer terug naar de lobby",
        "de": "Zurück zur Lobby",
        "es": "Regresar al lobby",
        "pt": "Voltar ao lobby",
        "cz": "Vrátit se do lobby",
        "fr": "Retour au salon",
        "it": "Torna alla lobby",
        "jr": "Return to port",
        "jp": "ロビーに戻る",
        "ru": "Вернуться в лобби"
    },
    {
        "textId": "multiplayer_tochat",
        "us": "To chat click here or press 'Enter' key",
        "nl": "Klik hier of druk op Enter om te chatten",
        "es": "Haz clic aquí o pulsa Intro para chatear",
        "pt": "Clica aqui ou prime Enter para conversar",
        "fr": "Cliquez ici ou appuyez sur Entrée pour discuter",
        "it": "Per chattare clicca qui o premi invio",
        "jr": "Click here or press Enter to chat with yer crew",
        "jp": "ここをクリックするか、Enterキーを押すとチャットできます",
        "ru": "Для чата нажмите здесь или нажмите клавишу «Enter»",
        "de": "Klicke hier oder drücke die Eingabetaste, um zu chatten",
        "cz": "Pro chat klikni sem nebo stiskni Enter"
    },
    {
        "textId": "multiplayer_invitelink",
        "us": "Invite link",
        "nl": "Uitnodigingslink",
        "de": "Einladungslink",
        "es": "Enlace de invitación",
        "pt": "Ligação de convite",
        "cz": "Odkaz na pozvání",
        "fr": "Lien d'invitation",
        "it": "Link di invito",
        "jr": "X marks the spot",
        "jp": "招待リンク",
        "ru": "Ссылка-приглашение"
    },
    {
        "textId": "multiplayer_copied",
        "us": "copied",
        "nl": "gekopieerd",
        "de": "kopiert",
        "es": "copiado",
        "pt": "copiado",
        "cz": "zkopírováno",
        "fr": "copié",
        "it": "copiato",
        "jp": "コピーしました",
        "ru": "Скопировано",
        "jr": "copied, matey"
    }
]
init();
